import { SxProps, Theme } from "@mui/material/styles";
import { couleurPrimaire } from "../../../theme";

const styles: SxProps<Theme> = [
  {
    "&.container": {
      display: "block",
    },
    "& .logoFI": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "& img": {
        paddingTop: "12px",
        width: 300,
      },
    },
    "& .texte": {
      display: "flex",
      maxWidth: "880px",
      font: "16 bold",
      padding: "20px 12px 48px 12px",
      marginLeft: "auto",
      marginRight: "auto",
      position: "relative",
    },
    "& .vertuloo": {
      color: couleurPrimaire,
    },
    "@media all and (max-width: 1000px)": {
      "&.container": {
        flexDirection: "column",
        "& iframe": {
          marginRight: 0,
          marginBottom: "24px",
        },
      },
    },
  },
];

export default styles;
